module.exports = __webpack_public_path__ + "dceaeb85f793321e77408290521d73d9.svg";